<template>
  <div>
    <b-card header-tag="header" footer-tag="footer" class="shadow w-md-50 mb-3">
      <template v-slot:header>
        <h4
          class="m-0 font-weight-bold text-site-primary"
        >{{ client && client.user ? client.user.username : '' }}</h4>
      </template>

    </b-card>

    <!-- Credit Groups -->
    <CreditGroupList
      :clientId="clientId"
      :restrictedMode="true"
    ></CreditGroupList>

    <!-- Examinees -->
    <ExamineeList
      :clientId="clientId"
      :restrictedMode="true"
    ></ExamineeList>
  </div>
</template>

<script>
import CreditGroupList from "../admin/CreditGroupList"
import ExamineeList from "./ExamineeList";
export default {
  name: `ClientView`,
  components: {
    CreditGroupList,
    ExamineeList,
  },
  data() {
    return {
      client: null,
      examineeList: null,
    };
  },
  computed: {
    nonActiveExamineeCount() {
      let examineeList = this.examineeList || [];
      var count = 0;
      examineeList.forEach((examinee) => {
        if (examinee.status == `created`) count++;
      });
      return count;
    },
    clientId(){
      var clientId = this.$store.getters[`user/roleId`]
      return `${clientId}`;
    }
  },
  mounted() {
    this.getClient();
  },
  methods: {
    getClient() {
      const id = this.clientId
      if (!id || isNaN(id)) {
        this.$router.push("../");
      } else {
        this.$store
          .dispatch("client/get", { id })
          .then((data) => (this.client = data.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>